import styled from 'styled-components';

export const ForceInstagramRegisterComponent = styled.div``;
export const BackButtonContainer = styled.div`
  * {
    text-decoration: none;
    color: ${props => props.theme.text.primary};
    &:active {
      color: white;
    }
  }
`;
